import { render } from "./DirectivesListPage.vue?vue&type=template&id=55310e92&scoped=true"
import script from "./DirectivesListPage.vue?vue&type=script&lang=js"
export * from "./DirectivesListPage.vue?vue&type=script&lang=js"

import "./DirectivesListPage.vue?vue&type=style&index=0&id=55310e92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55310e92"]])

export default __exports__